<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="clientClassification"
      :items="clientClassification"
      :fields="clientClassificationFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
      <editModal
      :editItem="selectedСlientClassification"
      :isEdit="isEdit"
      :clientClassification="clientClassification"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: false,
      clientClassificationFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'test', label: this.$i18n.t('Test'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedСlientClassification: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedСlientClassification = {
        'name': '',
        'test': '',
        'option-data': []
      }
      this.$root.$emit('bv::show::modal', 'modalEditClientClassification', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedСlientClassification = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditClientClassification', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Client classification"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let del = JSON.parse(JSON.stringify(this.clientClassification))
      del = del.filter((value) => {
        return value.numClientClass !== item.numClientClass
      })
      let DHCP = {
        'is_test_only': false,
        'loop_count_timeout': 35,
        'config': {}
      }
      DHCP.config = copy.arguments
      DHCP.config.Dhcp6['client-classes'] = del
      let response = this.$store.dispatch('Settings/SAVE_DHCPV6', DHCP)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    clientClassification () {
      let DHCPV6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let copy = DHCPV6.arguments.Dhcp6['client-classes']
      let numClientClass = 0
      let numOptionData = 0
      for (let el of copy) {
        el.numClientClass = ++numClientClass
        for (let elData of el['option-data']) {
          elData.numOptionData = ++numOptionData
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DHCPV6')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/DHCPv6/clientClassification/main.vue